import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Login from './Login';

function AuthWrapper({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);

  const checkAuthStatus = () => {
    try {
      // Check localStorage for authentication data
      const authData = localStorage.getItem('auth');
      if (authData) {
        const parsed = JSON.parse(authData);
        // Check if token exists and is not expired (simple check)
        if (parsed.token && parsed.user) {
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem('auth');
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      localStorage.removeItem('auth');
      setIsAuthenticated(false);
    }
    setAuthLoading(false);
  };

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
  };

  // Check authentication on component mount
  useEffect(() => {
    checkAuthStatus();
  }, []);

  // Show loading spinner while checking authentication
  if (authLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-perzsi-yellow mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  // Show the protected component if authenticated
  return children;
}

export default AuthWrapper;
